import styled from "styled-components"

const FrontElement = styled.div<{ distance?: number }>`
p{
  margin-top: 0;
}
img{
  width: 100%;
  margin: 2rem 0;
}
text-align: left;
background-color: var(--site-background);
color: var(--text-color);
font-size: 18px;
padding: 30px;
padding-bottom: 15px;
border-radius: 5px;
max-width: 80%;
margin-left: auto;
margin-right: auto;
font-family: var(--font-serif);
line-height: 3rem;
max-width: 606px;
 /* box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 100px 80px rgba(0, 0, 0, 0.12); */
  box-shadow:
  0px 4.5px 1.3px rgba(0, 0, 0, 0.03),
  0px 8.6px 3.1px rgba(0, 0, 0, 0.035),
  0px 12.7px 5.5px rgba(0, 0, 0, 0.037),
  0px 17.3px 9.2px rgba(0, 0, 0, 0.038),
  0px 23.4px 15.1px rgba(0, 0, 0, 0.04),
  0px 33.5px 26.4px rgba(0, 0, 0, 0.047),
  0px 60px 57px rgba(0, 0, 0, 0.07)
;

&.high {
  margin-top: 300px;
}
@media only screen and (max-width: 711px) {
  /* max-width: calc(100% + 1rem);
  width: calc(100% + 1rem); */
  /* margin-left: -2rem; */
  padding-right: 2rem;
  padding-left: 15px;
  padding-right: 15px;
}
`
export default FrontElement